var _path, _path2, _path3, _line, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 174,
    viewBox: "0 0 224 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.324 25.4684C35.324 18.1705 41.2401 12.2544 48.538 12.2544H164.161C171.459 12.2544 177.375 18.1705 177.375 25.4684V114.663C177.375 121.961 171.459 127.877 164.161 127.877H48.538C41.2401 127.877 35.324 121.961 35.324 114.663V25.4684Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.161 15.5579H48.538C43.0646 15.5579 38.6275 19.995 38.6275 25.4684V114.663C38.6275 120.137 43.0646 124.574 48.538 124.574H164.161C169.634 124.574 174.072 120.137 174.072 114.663V25.4684C174.072 19.995 169.634 15.5579 164.161 15.5579ZM48.538 12.2544C41.2401 12.2544 35.324 18.1705 35.324 25.4684V114.663C35.324 121.961 41.2401 127.877 48.538 127.877H164.161C171.459 127.877 177.375 121.961 177.375 114.663V25.4684C177.375 18.1705 171.459 12.2544 164.161 12.2544H48.538Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.324 25.4684C35.324 18.1705 41.2401 12.2544 48.538 12.2544H164.161C171.459 12.2544 177.375 18.1705 177.375 25.4684V41.986H35.324V25.4684Z",
    fill: "#1570EF",
    fillOpacity: 0.26
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.2847,
    y1: 42.5,
    x2: 177.285,
    y2: 42.5,
    stroke: "#1570EF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5381 27.1202C48.5381 26.2079 49.2776 25.4684 50.1898 25.4684H53.4934C54.4056 25.4684 55.1451 26.2079 55.1451 27.1202V30.4237C55.1451 31.3359 54.4056 32.0754 53.4934 32.0754H50.1898C49.2776 32.0754 48.5381 31.3359 48.5381 30.4237V27.1202Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4485 27.1202C58.4485 26.2079 59.188 25.4684 60.1002 25.4684H63.4038C64.316 25.4684 65.0555 26.2079 65.0555 27.1202V30.4237C65.0555 31.3359 64.316 32.0754 63.4038 32.0754H60.1002C59.188 32.0754 58.4485 31.3359 58.4485 30.4237V27.1202Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3594 27.1202C68.3594 26.2079 69.0989 25.4684 70.0111 25.4684H73.3146C74.2269 25.4684 74.9664 26.2079 74.9664 27.1202V30.4237C74.9664 31.3359 74.2269 32.0754 73.3146 32.0754H70.0111C69.0989 32.0754 68.3594 31.3359 68.3594 30.4237V27.1202Z",
    fill: "#1570EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4838 70.0659C91.4838 72.8026 89.2652 75.0211 86.5285 75.0211C83.7918 75.0211 81.5732 72.8026 81.5732 70.0659C81.5732 67.3291 83.7918 65.1106 86.5285 65.1106C89.2652 65.1106 91.4838 67.3291 91.4838 70.0659Z",
    fill: "#1570EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.43 70.0659C134.43 72.8026 132.211 75.0211 129.474 75.0211C126.738 75.0211 124.519 72.8026 124.519 70.0659C124.519 67.3291 126.738 65.1106 129.474 65.1106C132.211 65.1106 134.43 67.3291 134.43 70.0659Z",
    fill: "#1570EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0908 88.2352C98.0908 89.5366 98.3471 90.8253 98.8452 92.0277C99.3432 93.2302 100.073 94.3227 100.994 95.243C101.914 96.1632 103.006 96.8932 104.209 97.3913C105.411 97.8893 106.7 98.1457 108.001 98.1457C109.303 98.1457 110.592 97.8893 111.794 97.3913C112.996 96.8932 114.089 96.1632 115.009 95.243C115.929 94.3227 116.659 93.2302 117.157 92.0277C117.656 90.8253 117.912 89.5366 117.912 88.2352L115.615 88.2352C115.615 89.235 115.418 90.2251 115.035 91.1488C114.653 92.0725 114.092 92.9119 113.385 93.6189C112.678 94.3259 111.839 94.8867 110.915 95.2693C109.991 95.6519 109.001 95.8489 108.001 95.8489C107.001 95.8489 106.011 95.6519 105.088 95.2693C104.164 94.8867 103.325 94.3259 102.618 93.6189C101.911 92.9119 101.35 92.0725 100.967 91.1488C100.585 90.2251 100.388 89.235 100.388 88.2352L98.0908 88.2352Z",
    fill: "#1570EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4684_86)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112,
    cy: 136.397,
    rx: 93.7155,
    ry: 19.4733,
    fill: "#B4D3FF",
    fillOpacity: 0.31
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.285 25C192.285 38.8071 181.092 50 167.285 50C153.478 50 142.285 38.8071 142.285 25C142.285 11.1929 153.478 0 167.285 0C181.092 0 192.285 11.1929 192.285 25Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.285 47.619C179.777 47.619 189.904 37.4922 189.904 25C189.904 12.5078 179.777 2.38095 167.285 2.38095C154.793 2.38095 144.666 12.5078 144.666 25C144.666 37.4922 154.793 47.619 167.285 47.619ZM167.285 50C181.092 50 192.285 38.8071 192.285 25C192.285 11.1929 181.092 0 167.285 0C153.478 0 142.285 11.1929 142.285 25C142.285 38.8071 153.478 50 167.285 50Z",
    fill: "#1570EF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4684_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.201 18.5V23.75H162.701",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.368 32.5V27.25H171.868",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.067 22.875C174.602 21.6209 173.812 20.4997 172.771 19.616C171.729 18.7323 170.47 18.1148 169.11 17.8212C167.751 17.5277 166.336 17.5676 164.997 17.9372C163.659 18.3068 162.44 18.9941 161.455 19.935L157.201 23.75M177.368 27.25L173.115 31.065C172.13 32.0059 170.911 32.6932 169.572 33.0628C168.233 33.4325 166.818 33.4723 165.459 33.1788C164.1 32.8852 162.841 32.2677 161.799 31.384C160.757 30.5003 159.967 29.3791 159.502 28.125",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4684_86",
    x: 0.184668,
    y: 98.8236,
    width: 223.631,
    height: 75.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.05,
    result: "effect1_foregroundBlur_4684_86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4684_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(156.285 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.22936cc25ac41ce316f743e6e55f7ef3.svg";
export { ForwardRef as ReactComponent };